
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { postEmailTokenAction } from '../../redux/actions/gailActions';

function VerifyEmail() {
  
  const location = useLocation();
  const dispatch = useDispatch();

  const emailData = useSelector((state) => state.gail.emailResponse);

  const getQueryParams = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };

  const token = getQueryParams('token');

  useEffect(() => {
    const postToken = async () => {
      try {
        const formData = { token: token };
        await dispatch(postEmailTokenAction(formData));
      } catch (error) {
        console.error("Error posting token:", error);
      }
    };

    if (token) {
      postToken();
    }
  }, [token, dispatch]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center' }}>
      {emailData ? (
        <div>
          <h2>{emailData.message}</h2>
          <p>Account Created: {emailData.isAccountCreated ? "Yes" : "No"}</p>
          <p>Verified: {emailData.isVerified ? "Yes" : "No"}</p>
        </div>
      ) : (
        <h2>Verifying email, please wait...</h2>
      )}
    </div>
  );
}

export default VerifyEmail;
